import AddUpdateProjectModal from "./AddUpdateProjectModal";
import { HiOutlineBriefcase } from "react-icons/hi";
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import CustomButton from '../../../components/common/CustomButton';
import ImportDrawer from '../../../components/Modals/ImportDrawer';
import Portal from "../../../components/Portal";
import { resetTimelineState } from "../../../redux/slices/timeline";
import { useDispatch } from "react-redux";
import { resetRoadmap } from "../../../redux/slices/roadmap";
import CreateWorkUnit from "../../../features/CreateWorkUnit/CreateWorkUnit";

interface AddProjectProps {
  isVisible?: boolean,
  setShowModal?: any,
  selectedProject?: any,
  handleProjectClick?: any,
}

const AddProject: React.FC<AddProjectProps> = ({ isVisible, setShowModal, selectedProject = {}, handleProjectClick }: AddProjectProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [importDrawerProps, setImportDrawerProps] = useState<{
    initialIntegration?: 'jira' | 'azure' | 'asana' | 'monday';
    initialTab?: 'import' | 'states' | 'sprints';
    openManageProjects?: boolean;
  }>({});
  const [showImportDrawer, setShowImportDrawer] = useState(false);

  useEffect(() => {
    if (location.hash && location.hash.startsWith('#importproject')) {
      const hash = location.hash;
      // Support formats: #importproject, #importproject=jira, #importproject=jira&tab=sprints, #importproject=azure&manageProjects=true
      if (hash.includes('=')) {
        const hashContent = hash.substring('#importproject='.length); // e.g. 'jira&tab=states'
        const segments = hashContent.split('&');
        const integration = segments[0] as any;
        
        const newProps: any = { initialIntegration: integration };
        
        // Parse additional params like tab=states or tab=sprints or manageProjects=true
        for (let i = 1; i < segments.length; i++) {
          const [key, value] = segments[i].split('=');
          if (key === 'tab' && value) {
            newProps.initialTab = value as 'import' | 'states' | 'sprints';
          }
          if (key === 'manageProjects' && value === 'true') {
            newProps.openManageProjects = true;
          }
        }
        
        setImportDrawerProps(newProps);
      } else {
        setImportDrawerProps({});
      }
      setShowImportDrawer(true);
    }
  }, [location.hash]);

  const handleOnClick = () => {
    dispatch(resetTimelineState());
    dispatch(resetRoadmap());
    if (selectedProject.project_name) {
      handleProjectClick({}, !isVisible)
    } else {
      setShowModal(true)
    }
  }

  const handleViewTemplateClick = () => {
    navigate("/templates")
  }

  return (
    <div className="w-full md:w-auto flex flex-col md:flex-row mb-3 md:mb-0 items-stretch md:items-center justify-end md:space-x-3 flex-shrink-0 ml-auto">
      <CustomButton
        onClick={() => {
          setImportDrawerProps({});
          setShowImportDrawer(true);
        }}
        className="whitespace-nowrap bg-light-surfacePrimary hover:bg-light-surfaceHover !text-black dark:!text-white dark:bg-secondary-dark dark:hover:bg-tertiary-dark border
        dark:border-slate-700  border-light-border-default hover:border-light-border-interactive px-4 py-2 shadow-sm hover:shadow-md transition-all duration-200"
      >
        Import Project
      </CustomButton>
      <CustomButton
        onClick={handleViewTemplateClick}
        className="whitespace-nowrap bg-light-surfacePrimary !text-black dark:!text-white hover:bg-light-surfaceHover dark:bg-secondary-dark dark:hover:bg-tertiary-dark border
        dark:border-slate-700  border-light-border-default hover:border-light-border-interactive px-4 py-2 shadow-sm hover:shadow-md transition-all duration-200"
      >
        View templates
      </CustomButton>

      <CustomButton
        onClick={handleOnClick}
        leftIcon={<HiOutlineBriefcase className="text-xl" />}
        className="whitespace-nowrap createnewProject"
        data-onboarding-id="create-project-btn"
      >
        Create New
      </CustomButton>

      {isVisible && (
        <Portal>
          <CreateWorkUnit
            isVisible={isVisible}
            onClose={() => setShowModal(false)}
          />
        </Portal>
      )}

      <Portal>
        <ImportDrawer
          isOpen={showImportDrawer}
          onClose={() => {
            setShowImportDrawer(false);
            // Clear props on close to reset state
            setTimeout(() => setImportDrawerProps({}), 300);
          }}
          initialIntegration={importDrawerProps.initialIntegration}
          initialTab={importDrawerProps.initialTab}
          openManageProjects={importDrawerProps.openManageProjects}
        />
      </Portal>
    </div>

  )
}

export default AddProject;